/*///////////////////////////////////////////
////
////common javascript
////2019.10.05 maked
////copyright : d-techno
////
///////////////////////////////////////////*/

/////////////////////////////////
//contentsFadeIn
/////////////////////////////////
// 出現コンテンツの種類は下でコントロールして下さい。
// var hideContents = 'header,#sec1,#sec2,#sec3,#sec4,#sec5,footer';
// $(function(){
// 	$(hideContents).hide(); 
// });
// var i = 0;
// var int=0;
// $(window).bind("load", function() {
// 	var int=setInterval("doFade(i)",200);
// });
// function doFade() {
// 	var list = $(hideContents).length;
// 	if (i >= list) {
// 		clearInterval(int);
// 	}
// $(hideContents).eq(i).fadeIn(500);
// 	i++;
// }

$(window).on('load scroll', function(){
	$(".l_anim,.r_anim,.c_anim").each(function(){
		var position = $(this).offset().top; //ページの一番上から要素までの距離を取得
		var scroll = $(window).scrollTop(); //スクロールの位置を取得
		var windowHeight = $(window).height(); //ウインドウの高さを取得
		if (scroll > position - windowHeight){ //スクロール位置が要素の位置を過ぎたとき
		  $(this).addClass('active'); //クラス「active」を与える
	}
	});
});

/*Twitterウィジェットフォントサイズ調整*/
function changeTwitterWidgetDesign(){
	var $twitter_widget = $('iframe.twitter-timeline');
	var $twitter_widget_contents = $twitter_widget.contents();
	if ($twitter_widget.length > 0 && $twitter_widget[0].contentWindow.document.body.innerHTML !== ""){
	$twitter_widget_contents.find('head').append('<link href="css/twitter.css" rel="stylesheet" type="text/css">');
	}
	else {
		setTimeout(function(){
		changeTwitterWidgetDesign();
		}, 350);
	}
}
changeTwitterWidgetDesign();


// sample_voice
// $(document).ready( function() {
// 	var audio = audiojs.createAll({
// 		trackEnded: function() {
// 			$('.btn_voice').removeClass('ani_play');
// 			console.log("trackend");
// 		}
// 	});
// 	$('audio').attr('src', '../sound/character/maple/maple_voice_1.mp3');
// 	function randomAudio() {
// 		audio[0].pause();
// 		audio[0].currentTime = 0;
// 		audio[0].load($('audio').attr('src'));
// 		audio[0].play();
// 		audio.controls = true;
// 	}
// 	$('#maple_voice_1').click( function() {
// 		$('audio').attr('src', '../sound/character/maple/maple_voice_1.mp3');
// 		$('#maple_voice_1').addClass('ani_play');
// 		randomAudio();
// 	});

// 	$('#maple_voice_2').click( function() {
// 		$('audio').attr('src', '../sound/character/maple/maple_voice_2.mp3');
// 		$('#maple_voice_2').addClass('ani_play');
// 		randomAudio();
// 	});
// 	$('#sally_voice_1').click( function() {
// 		$('audio').attr('src', '../sound/character/sally/sally_voice_1.mp3');
// 		$('#sally_voice_1').addClass('ani_play');
// 		randomAudio();
// 	});

// 	$('#sally_voice_2').click( function() {
// 		$('audio').attr('src', '../sound/character/sally/sally_voice_2.mp3');
// 		$('#sally_voice_2').addClass('ani_play');
// 		randomAudio();
// 	});

// });



/////////////////////////////////
// uncher link setting
/////////////////////////////////
// $(function(){
// 	// #で始まるアンカーをクリックした場合に処理
// 	$('a[href^="#"]').click(function() {
// 	   // スクロールの速度
// 		var speed = 400; // ミリ秒
// 		var headerHight = $("#product_header").outerHeight();
// 	   // アンカーの値取得
// 		var href= $(this).attr("href");
// 		// 移動先を取得
// 		var target = $(href == "#" || href == "" ? 'html' : href);
// 		// 移動先を数値で取得
// 		var position = target.offset().top-headerHight;
// 		// スムーススクロール
// 		$('body,html').animate({scrollTop:position}, speed, 'swing');
// 		return false;
// 	});
// });

/////////////////////////////////
// スマホナビ設定
/////////////////////////////////
// $(document).ready(function(){
// 	$("#nav_toggle").on("click", function() {
// 		var _class = $(this).attr("class");
// 		if(_class == "close"){
// 		$(this).addClass("open");
// 		$(this).removeClass("close");
// 		$('header .inner').animate({ right:'-20%',opacity:'1'},500,'swing');
// 		$('header .inner').css('height','100vh');
// 		}else{
// 		$(this).addClass("close");
// 		$(this).removeClass("open");
// 		$('header .inner').animate({ right:'-100%',opacity:'0'},500,'swing');
// 		$('.close').removeClass('open');
// 		}
// 	});
// });

/////////////////////////////////
// ウィンドウリサイズ設定
/////////////////////////////////
//PC
// var minWidth = 768;
// if (minWidth <= $(this).width()) {
// 	$(window).resize(function () {
// 		// hsize = $(window).height();
// 		// $("#sec1").css("height", hsize + "px")
// 		$('header .inner').removeAttr('style');
// 	});
// }
//SP
// if (minWidth >= $(this).width()) {

// }

/////////////////////////////////
// ロールオーバー設定
/////////////////////////////////
(function($){
	$.fn.tgImageRollover = function(options){
		var opts = $.extend({}, $.fn.tgImageRollover.defaults, options);
		$(opts.selector).each(
			function(){
				this.onImage = $(this).attr('src').replace(/^(.+)(\.[a-z]+)$/,"$1"+ opts.attach +"$2");
				this.onHtml = $('<img src="'+this.onImage+'" alt="" style="position:absolute; opacity:0;" />');
				$(this).before(this.onHtml);

				$(this.onHtml).hover(
					function(){
						$(this).stop().animate({'opacity': '1'}, opts.onFadeTime);
					},
					function(){
						$(this).stop().animate({'opacity': '0'}, opts.offFadeTime);
					}
				)
			}
		)
	}
	// default option
	$.fn.tgImageRollover.defaults = {
		selector : 'img.rollover',
		attach : '_on',
		onFadeTime : 600,
		offFadeTime : 400,
	};
})(jQuery);
// run
jQuery(function(){
	$(this).tgImageRollover({
		selector : 'img.roll',     // セレクタ ←(7)
		attach : '_o',                 // ファイル名末尾句 ←(8)
		onFadeTime : 600,              // カーソルON時のアニメーション時間 ←(9)
		offFadeTime : 400              // カーソルOFF時のアニメーション時間 ←(10)
	});
});

/////////////////////////////////
//page_topback_btn
/////////////////////////////////
$(document).ready(function(){
	$("#pageTop").hide();
	// ↑ページトップボタンを非表示にする
	$(window).on("scroll", function() {
		if ($(this).scrollTop() > 100) {
			// ↑ スクロール位置が100よりも小さい場合に以下の処理をする
			$('#pageTop').fadeIn("fast");
			// ↑ (100より小さい時は)ページトップボタンをスライドダウン
		} else {
			$('#pageTop').fadeOut("fast");
			// ↑ それ以外の場合の場合はスライドアップする。
		}
	// フッター固定する
		scrollHeight = $(document).height();
		// ドキュメントの高さ
		scrollPosition = $(window).height() + $(window).scrollTop(); 
		//　ウィンドウの高さ+スクロールした高さ→　現在のトップからの位置
		footHeight = $("footer").innerHeight() - $("#pageTop").innerHeight() / 2 ;
		// フッターの高さ
		if ( scrollHeight - scrollPosition  <= footHeight ) {
		// 現在の下から位置が、フッターの高さの位置にはいったら
		//  "#pageTop"のpositionをabsoluteに変更し、フッターの高さの位置にする
			$("#pageTop").css({
				"position":"absolute",
				"bottom": footHeight
			});
		} else {
		// それ以外の場合は元のcssスタイルを指定
			$("#pageTop").css({
				"position":"fixed",
				"bottom": "2%",
				"right":"2%"
			});
		}
	});
	//トップへスムーススクロール
	$('#pageTop a').click(function () {
		$('body,html').animate({
		scrollTop: 0
		}, 500);
		// ページのトップへ 500 のスピードでスクロールする
		return false;
	});
});

$(function(){
	$('a[href^="#"]').click(function(){
	var speed = 500;
	var href= $(this).attr("href");
	var target = $(href == "#" || href == "" ? 'html' : href);
	var position = target.offset().top;
	$("html, body").animate({scrollTop:position}, speed, "swing");
	return false;
	});
});

/////////////////////////////////
//loader
/////////////////////////////////

$(function() {
	var h = $(window).height();
	$('#wrap').css('display','none');
	$('#loader-bg ,#loader').height(h).css('display','block');
});

/////////////////////////////////
//windowload設定
/////////////////////////////////
$(window).load(function () { //全ての読み込みが完了したら実行
	$('#loader-bg').delay(900).fadeOut(800);
	$('#loader').delay(600).fadeOut(300);
	$('#wrap').css('display', 'block');
//////////////////////////////////
});
//10秒たったら強制的にロード画面を非表示
$(function(){
	setTimeout('stopload()',10000);
});
function stopload(){
	$('#wrap').css('display','block');
	$('#loader-bg').delay(900).fadeOut(800);
	$('#loader').delay(600).fadeOut(300);
}

/////////////////////////////////
//auto list class_name
/////////////////////////////////

$(function(){
	$('ul').each(function(){
		$(this).find('li:first').addClass('first');
		$(this).find('li:odd').addClass('odd');
		$(this).find('li:even').addClass('even');
		$(this).find('li:last').addClass('last');
	});
	$('table').each(function(){
		$(this).find('tr:first').addClass('first');
		$(this).find('tr:odd').addClass('odd');
		$(this).find('tr:even').addClass('even');
		$(this).find('tr:last').addClass('last');
	});
	$('dl').each(function(){
		$(this).find('dt:first').addClass('first');
		$(this).find('dt:odd').addClass('odd');
		$(this).find('dt:even').addClass('even');
		$(this).find('dt:last').addClass('last');
		$(this).find('dd:first').addClass('first');
		$(this).find('dd:odd').addClass('odd');
		$(this).find('dd:even').addClass('even');
		$(this).find('dd:last').addClass('last');
	});
});

/* run
-----------------------------------------------------------------------------------------------*/
// $(function(){
// 	$('.matchH').matchHeight();
// });

